import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import { muiTheme } from '../../theme';

const MainLayout: React.FC = () => {
  return (
    <ThemeProvider theme={muiTheme}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        backgroundColor: '#E7EFF5',
        margin: 0,
        padding: 0,
        width: '100%'
      }}>
        <Box sx={{ 
          flex: 1,
          width: '100%',
          margin: 0,
          padding: '0px',
          boxSizing: 'border-box',
        }}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MainLayout; 